module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header-all"
  }, [_c('v-header', {
    attrs: {
      "type": _vm.showType.H5
    }
  })], 1), _vm._v(" "), (_vm.showTop) ? _c('v-result', {
    attrs: {
      "type": _vm.showType.H5,
      "types": _vm.headType.h5Main
    }
  }, [_c('v-banner', {
    attrs: {
      "banners": _vm.banner
    }
  }), _vm._v(" "), _c('v-cate', {
    attrs: {
      "cates": _vm.category,
      "cdn": _vm.cdn
    }
  }), _vm._v(" "), (!_vm.isWeixin) ? _c('v-newHomePage', {
    attrs: {
      "datas": _vm.newhomePageData,
      "hotGoodsIdx": _vm.hotGoodsIdx,
      "goodShop": _vm.goodShop,
      "jdShareRatio": _vm.jdShareRatio
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "h5-foot-contain"
  }, [_c('div', {
    staticClass: "banner-contain"
  }, [_c('v-totalheader', {
    attrs: {
      "type": _vm.headType.h5Main
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f48723e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/H5.vue
// module id = 212
// module chunks = 2